import React from 'react'
import './About.css'

function About() {
  return (
    <>
      <div className = 'container'> <h1>About Me</h1> 
      <p>I am a junior Computer Science student at the University of Nevada, Las Vegas, with a strong interest in cloud computing. I am currently exploring machine learning and artificial intelligence to integrate them into my projects, with the goal of pursuing a career in cloud engineering. </p>
       </div>

       <div className = 'Hobbies'>
          <h1>Hobbies</h1>
          <p>Hiking</p>
          <p>Traveling</p>
          <p>Coding</p>
          <p>Cooking</p>
          <p>Gaming</p>
       </div>
    </>
  )
}

export default About